const menuLinks = [
    {
        group: 'Mosques',
        link: '/mosques',
        items: [],
    },
    {
        group: 'Timetables',
        link: '/timetables',
        items: [],
    },
    {
        group: 'Subscriptions',
        link: '/subscriptions',
        items: [],
    },
    {
        group: 'Resources',
        link: '/resources',
        items: [],
    },
    {
        group: 'Users',
        link: '/users',
        items: [],
    },
];

export default menuLinks;
